import { RootState } from '../store';

export const selectCurrentPatientState = (state: RootState): any => state.currentPatientState;
